import { render, staticRenderFns } from "./LifestylePage.vue?vue&type=template&id=6d8e6f4a&"
import script from "./LifestylePage.vue?vue&type=script&lang=js&"
export * from "./LifestylePage.vue?vue&type=script&lang=js&"
import style0 from "./LifestylePage.vue?vue&type=style&index=0&id=6d8e6f4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports